import React from 'react';
import PropTypes from 'prop-types';
import './SettingIndicator.css';

const cool = require('./assets/cool-icon.png');
const coolOffline = require('./assets/cool-offline-icon.png');
const heat = require('./assets/heat-icon.png');
const heatOffline = require('./assets/heat-offline-icon.png');
const off = require('./assets/off-icon.png');
const offOffline = require('./assets/off-offline-icon.png');

export const SettingIndicator = (props) => {
  const { setting, reset } = props;

  switch (setting) {
    case 'cool':
      return (reset) ? (
        <img className="setting-indicator" src={coolOffline} alt="disconnected" />
      ) : (
        <img className="setting-indicator" src={cool} alt="cool setting" />
      );
    case 'heat':
      return (reset) ? (
        <img className="setting-indicator" src={heatOffline} alt="disconnected" />
      ) : (
        <img className="setting-indicator" src={heat} alt="heat setting" />
      );
    case 'off':
      return (reset) ? (
        <img className="setting-indicator" src={offOffline} alt="disconnected" />
      ) : (
        <img className="setting-indicator" src={off} alt="off" />
      );
    default:
      return null;
  }
};

SettingIndicator.propTypes = {
  setting: PropTypes.string.isRequired,
  reset: PropTypes.bool.isRequired,
};
